import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CollapseGlyph = /*#__PURE__*/createElement("g", {
  id: "collapse"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M32.6,21.8c-0.8,0-1.5,0.7-1.5,1.5V29L18.1,15.9c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1L29,31.1h-5.8 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h9.4c0.2,0,0.4,0,0.5-0.1c0,0,0,0,0,0c0.4-0.2,0.7-0.4,0.8-0.8c0,0,0,0,0,0 c0.1-0.2,0.1-0.4,0.1-0.5v-9.4C34.1,22.4,33.5,21.8,32.6,21.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M50,33.2c0.2,0.4,0.4,0.7,0.8,0.8c0,0,0,0,0,0c0.2,0.1,0.4,0.1,0.5,0.1h9.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H55 l13.1-13.1c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0L52.9,29v-5.8c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v9.4 C49.9,32.8,49.9,33,50,33.2C50,33.2,50,33.2,50,33.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M55,52.9h5.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-9.4c-0.2,0-0.4,0-0.5,0.1c0,0,0,0,0,0c-0.4,0.2-0.7,0.4-0.8,0.8 c0,0,0,0,0,0c-0.1,0.2-0.1,0.4-0.1,0.5v9.4c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V55l13.1,13.1c0.3,0.3,0.7,0.4,1.1,0.4 s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1L55,52.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M34,50.8c-0.2-0.4-0.4-0.7-0.8-0.8c0,0,0,0,0,0c-0.2-0.1-0.4-0.1-0.5-0.1h-9.4c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H29 L15.9,65.9c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4L31.1,55v5.8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5 v-9.4C34.1,51.2,34.1,51,34,50.8C34,50.8,34,50.8,34,50.8z"
})));
const Collapse = createSvg({
  name: 'collapse',
  path: CollapseGlyph
});

export default Collapse;
export { CollapseGlyph };
